module.exports = __webpack_public_path__ + "img/2.97267871.jpg";